import { createPageTableSchema } from '@state/_shared/tableComponentStateSchema';

// Define the specific structure for a row in the locations table
const userInventoryLocationsRowSchema = {
    type: 'object',
    properties: {
        id: { type: ['number', 'string'], default: '' },
        name: { type: 'string', default: '' },
        description: { type: ['string', 'null'], default: null },
        inventory_container_type_id: { type: ['number', 'null'], default: null },
        inventory_container_type_name: { type: ['string', 'null'], default: null },
        item_count: { type: 'number', default: 0 },
        lot_count: { type: 'number', default: 0 },
        exclude_from_recommendations: { type: 'boolean', default: false },
        always_available: { type: 'boolean', default: false },
        pile_volume: { type: ['number', 'null'], default: null },
        batch_pile_volume: { type: ['number', 'null'], default: null },
        container_volume: { type: ['number', 'null'], default: null },
        percent_full: { type: ['number', 'null'], default: null },
        has_weightless_items: { type: 'boolean', default: false },
    }
};

// Define specific row actions (if any) for this table
const userInventoryLocationsRowActions = {
    isUpdatingRecommendation: { type: 'boolean', default: false }, // Example if async update
    // Add other row-specific action states here
};

// Create the table schema specific to this page using the helper
const pageTableSchema = createPageTableSchema(userInventoryLocationsRowSchema, userInventoryLocationsRowActions);

// Define the state schema for the UserInventoryLocations page
const userInventoryLocationsStateSchema = {
    // Properties should be defined directly at the root level
    title: { 
        type: 'string', 
        default: 'Inventory Locations' // Define type and default directly
    },
    
    // Use the generated table schema structure directly
    table: pageTableSchema,
    
    // Define other page-level state (e.g., dialogs)
    dialogs: {
        type: 'object', // Add type for the dialogs object
        default: { // Set defaults within a default object
            isCreateOpen: false,
            isEditOpen: false,
            isDeleteConfirmOpen: false,
            itemToEdit: null,
            itemsToDelete: [],
        },
        properties: { // Define properties within the properties key
            isCreateOpen: { type: 'boolean', default: false },
            isEditOpen: { type: 'boolean', default: false }, // Example
            isDeleteConfirmOpen: { type: 'boolean', default: false }, // Example
            itemToEdit: { type: ['object', 'null'], default: null }, // Example
            itemsToDelete: { type: 'array', default: [] }, // Example
        },
    },
    
    // Delete conflict dialog state
    deleteConflictDialog: {
        type: 'object',
        default: {
            isOpen: false,
            conflictItems: [],
            locationId: null
        },
        properties: {
            isOpen: { type: 'boolean', default: false },
            conflictItems: { 
                type: 'array', 
                default: [],
                items: {
                    type: 'object',
                    properties: {
                        id: { type: 'number' },
                        name: { type: 'string' },
                        number: { type: 'string' },
                        quantity: { type: 'number' }
                    }
                }
            },
            locationId: { type: ['number', 'null'], default: null }
        }
    }
    // Removed initialState wrapper, validators, and actions keys as they are not standard schema definition
};

export default userInventoryLocationsStateSchema;
